import { render } from "./ConfigPanel.vue?vue&type=template&id=0b7a9762"
import script from "./ConfigPanel.vue?vue&type=script&lang=js"
export * from "./ConfigPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__